var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',_vm._b({class:[
        'vue-select-bulma',
        _vm.customClass
    ],attrs:{"value":_vm.selectValue,"disabled":_vm.disabled,"multible":_vm.multiple,"closeOnSelect":_vm.closeOnSelect,"append-to-body":_vm.appendToBody,"filter":_vm.filter,"clearable":_vm.clearable},on:{"input":_vm.onInput,"search":_vm.onSearch}},'v-select',_vm.$props,false),[_c('span',{attrs:{"slot":"no-options"},slot:"no-options"},[_vm._v("Ingen resultater fundet")])])
}
var staticRenderFns = []

export { render, staticRenderFns }